const { useState } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { PanelBody, TextControl, ToggleControl, SelectControl } = wp.components;
import { showContent } from '../functions/contentHandler';

export default function Inspector({ attributes, setAttributes, context }) {
  const { havePlans, plansId, parentTabId } = attributes;
  const tabsHeading = context['app/tabsHeading'];

  const [availableTabs] = useState(filterAvailableTabs);

  function handleParentTabChange(tab) {
    setAttributes({ parentTabId: tab });
    showContent(tab);
  }

  function filterAvailableTabs() {
    const newTabs = tabsHeading.map((heading) => {
      return { label: heading.title, value: heading.tabId };
    });

    return newTabs;
  }

  return (
    <InspectorControls>
      <PanelBody title={'Configurações da guia'} initialOpen={true}>
        <SelectControl
          label={'Guia a qual o conteúdo será atrelado'}
          value={parentTabId}
          options={availableTabs}
          onChange={(tab) => handleParentTabChange(tab)}
        />

        <ToggleControl
          label={'Essa guia irá conter o bloco de planos?'}
          help={"Bloco de planos = 'Integração Planos Tabs'"}
          checked={havePlans}
          onChange={(havePlans) => setAttributes({ havePlans })}
        />

        {attributes.havePlans && (
          <TextControl
            label={'ID da guia de planos'}
            value={plansId}
            onChange={(plansId) => setAttributes({ plansId })}
          />
        )}
      </PanelBody>
    </InspectorControls>
  );
}
